import PropTypes from 'prop-types';
import React from 'react';
import BodyClassName from 'react-body-classname';

export const FullScreenError = props => {
  let content;
  const { message, code } = props.error;

  if (code && code === 404) {
    content = (
      <div>
        <h1 className="title">404</h1>
        <p>
          Whoops!
          <br />
          That’s not how we wanted this to go.
        </p>
      </div>
    );
  } else {
    content = (
      <div>
        <h2 className="title">We are a bit busy right now!</h2>
        <p>
          We’re doing some heavy lifting at the moment.
          <br />
          Check back soon!
        </p>
      </div>
    );
  }

  return (
    <BodyClassName className="body--error body--no-footer body--render-error">
      <div className="render-error">
        <img className="render-error__arm" src={require('static/img/404-arm.png')} alt="Arm" width="599" height="548" />
        <img
          className="render-error__kettlebell"
          src={require('static/img/404-weight.png')}
          alt="Weight"
          width="654"
          height="464"
        />
        <section className="render-error__content">
          {content}
          <div className="hidden" data-code={code}>
            {message}
          </div>
        </section>
      </div>
    </BodyClassName>
  );
};

FullScreenError.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
    details: PropTypes.string,
    code: PropTypes.number,
  }).isRequired,
};
